// NOTE: esbuild移行の一環として、過去の仕様をそのままコピペしているため、
// esbuild配下では必要なものだけエクスポートするなど他リファクタリング必要。

// ============================================================================
// 応援のcallback用
const createCallback = (routes, story_id) => (response) => {
  if (response) {
    $.ajax({
      url: routes.supports_story_path(story_id),
      method: "post",
      dataType: "json",
    }).then(
      (data) => {
        $(`.jsStorySupport[data-id=${data.id}]`).addClass("isAdded");
        $(`.jsLikedPeople[data-id=${data.id}]`).html(data.liked_people_html);
        $(`.jsStoryCount[data-id=${data.id}]`).text(
          data.likes_count + data.supports_count
        );
        $(`.jsStoryCountWithIcon[data-id=${data.id}]`).text(
          data.supports_likes_count_exclude_displayed_icon
        );
        if (data.modal_html) {
          $("#modalStoryThanks").html(data.modal_html);
          $("#modalStoryThanks").modal("show");
        }
      },
      (_error) => {
        toastr.error(
          "現在問題の解決に取り組んでいます。大変申し訳ありません。",
          "応援に失敗しました。"
        );
      }
    );
  }
};

function twitter_share_for_support(routes) {
  window.twttr = (function (d, s, id) {
    let js;
    const fjs = d.getElementsByTagName(s)[0];
    const p = /^http:/.test(d.location) ? "http" : "https";
    const t = window.twttr || {};
    if (d.getElementById(id)) return t;
    js = d.createElement(s);
    js.id = id;
    js.src = `${p}://platform.twitter.com/widgets.js`;
    fjs.parentNode.insertBefore(js, fjs);

    t._e = [];
    t.ready = function (f) {
      t._e.push(f);
    };

    return t;
  })(document, "script", "twitter-wjs");

  let clicked_story_id = 0;

  $("#jsTwitterSupport").click(function () {
    // モーダルを閉じる .modal('hide');だとうまくいかない
    $(".close").click();

    const story_id = getClickedStoryId();

    if (clicked_story_id != story_id) {
      const callback = createCallback(routes, story_id);
      twttr.ready((twttr) => {
        twttr.events.unbind("tweet");
        twttr.events.bind("tweet", (intentEvent) => {
          callback(intentEvent);
          $("#jsTwitterSupport").attr("href", "");
        });
      });
      clicked_story_id = story_id;
    }

    const url = urlForClickedStory(story_id);
    const text = getClickedStoryTitle(); // TODO: twitterシェアの本文をカスタマイズする場合はここを変更
    const href = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      url
    )}&text=${encodeURIComponent(text)}&lang=ja`;
    $(this).attr("href", href);
    return true;
  });

  // modal_publish用 リファクタの余地あり
  $("#jsTwitterSupportPublish").click(function () {
    // モーダルを閉じる .modal('hide');だとうまくいかない
    $(".close").click();

    const story_id = getClickedStoryId();

    if (clicked_story_id != story_id) {
      const callback = createCallback(routes, story_id);
      twttr.ready((twttr) => {
        twttr.events.unbind("tweet");
        twttr.events.bind("tweet", (intentEvent) => {
          callback(intentEvent);
          $("#jsTwitterSupportPublish").attr("href", "");
        });
      });
      clicked_story_id = story_id;
    }

    const url = urlForClickedStory(story_id);
    const text = getClickedStoryTitle(); // TODO: twitterシェアの本文をカスタマイズする場合はここを変更
    const href = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      url
    )}&text=${encodeURIComponent(text)}&lang=ja`;
    $(this).attr("href", href);
    return true;
  });
}

function facebook_share_for_support(routes) {
  window.fbAsyncInit = function () {
    FB.init({
      appId: "XXXXXXXX",
      status: true,
      cookie: true,
      xfbml: true,
      version: "v2.8",
    });
  };

  function postToFeed(url, callback) {
    const obj = {
      method: "feed",
      link: url,
    };

    FB.ui(obj, callback);
  }
  const supportFB = document.getElementById("jsFacebookSupport");
  if (supportFB) {
    supportFB.onclick = function () {
      $(".close").click();
      const story_id = getClickedStoryId();
      const url = urlForClickedStory(story_id);
      const callback = createCallback(routes, story_id);
      postToFeed(url, callback);
    };
  }

  // modal_publish用 リファクタの余地あり
  const supportFBPublish = document.getElementById("jsFacebookSupportPublish");
  if (supportFBPublish) {
    supportFBPublish.onclick = function () {
      $(".close").click();
      const story_id = getClickedStoryId();
      const url = urlForClickedStory(story_id);
      const callback = createCallback(routes, story_id);
      postToFeed(url, callback);
    };
  }
}

function getClickedStoryId() {
  const story_id = $(".jsInitializeStoryShare[data-clicked=1]")
    .parent()
    .data("id");
  return story_id;
}

function getClickedStoryTitle() {
  const story_title = $(".jsInitializeStoryShare[data-clicked=1]")
    .parent()
    .data("title");
  return story_title;
}

function urlForClickedStory(story_id) {
  return window.location.href
    .replace("/manage", "")
    .replace(/stories.*/, `stories/${story_id}`);
}

// ============================================================================
// 応援依頼をclipboadにコピー
function setCopiedBtn() {
  $("#jsCopyButton").click(function (_e) {
    const story_id = getClickedStoryId();
    const url = urlForClickedStory(story_id);
    const supportRequestText = `${url}\nこちらのページの「応援」ボタンよりTwitterかFacebookでシェアをお願いします！`;

    const textarea = $(
      `<textarea class='u_width100p u_fontM u_font14 linkShare u_marBottom20' readonly>${supportRequestText}</textarea>`
    );
    $(this).parent().append(textarea);
    navigator.clipboard.writeText(supportRequestText).then(
      () => {
        $(this).parent().addClass("Copied");
      },
      () => {}
    );
  });
}

// NOTE: 応援ボタンをクリックした際にクリックしたボタンのみにフラグを立てる
function markClickedIcon(shareIcons, clickedIcon) {
  shareIcons.forEach((icon) => {
    icon.dataset.clicked = "";
  });
  clickedIcon.dataset.clicked = "1";
}

function setupShareIcons(shareIcons) {
  shareIcons.forEach((icon) => {
    icon.addEventListener("click", function () {
      markClickedIcon(shareIcons, this);
    });
  });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export {
  twitter_share_for_support,
  facebook_share_for_support,
  getClickedStoryId,
  getClickedStoryTitle,
  urlForClickedStory,
  setCopiedBtn,
  markClickedIcon,
  setupShareIcons,
};
